import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { isEmpty } from "lodash";

import "./Auth.scss";

const isNordicrouting = window.location.origin.includes("nordicrouting.se");
const lang = !isNordicrouting ? "en" : "se"; // Extend this logic to include more languages if needed

const text = {
  en: {
    loginToYourAccount: "Login to your account",
    workEmail: "Work Email",
    invalidEmail: "Invalid Email",
    required: "Required",
    forgotPassword: "Forgot Password?",
    password: "Password",
    dontHaveAccount: "Don't have an account?",
    register: "Register",
    documentation: "Parcelizer Documentation",
    stepByStep: "Step by step how to use our routing system",
  },
  se: {
    loginToYourAccount: "Logga in på ditt konto",
    workEmail: "Arbets-E-post",
    invalidEmail: "Ogiltig e-post",
    required: "Obligatorisk",
    forgotPassword: "Glömt lösenord?",
    password: "Lösenord",
    dontHaveAccount: "Har du inget konto?",
    register: "Registrera",
    documentation: "Parcelizer Dokumentation",
    stepByStep: "Steg för steg hur du använder vårt routing system",
  },
  fr: {
    loginToYourAccount: "Connectez-vous à votre compte",
    workEmail: "E-mail professionnel",
    invalidEmail: "E-mail invalide",
    required: "Requis",
    forgotPassword: "Mot de passe oublié?",
    password: "Mot de passe",
    dontHaveAccount: "Vous n'avez pas de compte?",
    register: "S'inscrire",
    documentation: "Documentation de Parcelizer",
    stepByStep: "Étape par étape comment utiliser notre système de routage",
  },
};

const SignInForm = ({ setParamsLogin, doSignIn, detailCode }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      email: detailCode?.email,
    });
  }, [detailCode]);

  const handleSubmit = params => {
    setParamsLogin(params);
    doSignIn(params);
  };

  return (
    <div className={`SignInForm ${!isEmpty(detailCode) ? "Invite" : ""}`}>
      <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
        <div className="Logo">
          <Link to="/">
            <img src={`/logo-${isNordicrouting ? "nordicrouting" : "parcelizer"}.svg`} alt="logo" />
          </Link>
        </div>
        {!isEmpty(detailCode) ? (
          <div className="FormHeader">
            <div className="Title">
              {detailCode.userName} has invited you to join {detailCode.companyName} on Parcelizer.
            </div>
            <div className="SubTitle">
              After signing in, you'll be able to see the details and statuses of all orders tagged to your account
            </div>
          </div>
        ) : (
          <div className="FormHeader">
            <div className="Title">{text[lang].loginToYourAccount}</div>
          </div>
        )}
        <div className="FormContent">
          <Form.Item
            label={text[lang].workEmail}
            name="email"
            rules={[
              { type: "email", message: text[lang].invalidEmail },
              { required: true, message: text[lang].required },
            ]}>
            <Input disabled={detailCode?.email} size="large" placeholder="name@company.com" />
          </Form.Item>
          <Form.Item
            label={text[lang].password}
            name="password"
            rules={[{ required: true, message: text[lang].required }]}>
            <Input.Password size="large" placeholder={text[lang].password} />
          </Form.Item>
          <div className="ForgotPassword">
            <Link to="/forgot-password">{text[lang].forgotPassword}</Link>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Login
          </Button>
        </div>
      </Form>
      <div className="Register">
        {text[lang].dontHaveAccount} <Link to="/register">{text[lang].register}</Link>
      </div>
      <Link to="#" className="Documentation">
        <div className="Left">
          <div className="Title">
            <img src="/icons/documentation.svg" alt="" />
            {text[lang].documentation}
          </div>
          <div className="Desc">{text[lang].stepByStep}</div>
        </div>
        <div className="Right">
          <img src="/icons/arrow-forward.svg" alt="" />
        </div>
      </Link>
    </div>
  );
};

export default SignInForm;
